export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10707.34513042.jpg";